import Statistic from "./Statistic";
import request from "../../../request";
import { capitalize } from "@mui/material";

export default function Deliveries() {

   return <Statistic
      title="Deliveries"
      variant="pie"
      fetchData={async (from, to) => {

         const res = await request.get('/api/general/reports/deliveries', { params: { from, to } });
         const { count } = res.data;

         const cards = [];

         for (const status in count) {

            if (status === "overall")
               continue;

            cards.push({
               title: capitalize(status),
               number: count[status]
            });
         }

         return [ { cards }]
      }}
   />
}